import { Component, Input, Output, ElementRef, OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { WindowService } from "../services/window.service";
import { Easing, EASING_TYPE } from "../utils/easing";
import { ProductGroup, AlternativeSelectedEvent } from "../model/product.group";
import { MainConfigurationInterface } from "../services/configuration.loader";
import { Product, ProductSelectedEvent } from "../model/product";
import { SubProduct, SubProductSelectedEvent, SubProductTabSelectedEvent } from "../model/subproduct";
import { EventsService } from "../services/events.service";
import { Logger } from "../utils/logger";
import { RowsIterator } from "../utils/rows.iterator";

import { TranslateService } from '@ngx-translate/core';

// import $ from "jquery";

@Component({
    selector: 'sidebar',
    templateUrl: "./sidebar.component.html"
})
export class SideBar implements OnInit, OnChanges {

    @Output('onHide')
    public displayEvent: EventEmitter<boolean>;

    @Input("productGroup")
    public productGroup: ProductGroup;

    public productsIterator: RowsIterator<Product> = null;

    @Input("show")
    // public needShow:boolean = false;
    public isShown = false;

    @Input()
    public configuration: MainConfigurationInterface = null;

    @Input()
    public productsFilters: Array<{ type: string, list: Array<any> }> = [];

    @Input()
    public alternativeNumber: number;

    @Output('onFilterPanel')
    public filterPanel: EventEmitter<any>;

    @Output('onProductInfo')
    public productInfo: EventEmitter<Product>;

    @Output('onProductSelected')
    public productSelected: EventEmitter<ProductSelectedEvent>;

    @Output('onSubProductSelected')
    public subProductSelected: EventEmitter<SubProductSelectedEvent>;

    @Output('onAlternativeSelected')
    public alternativeSelected: EventEmitter<AlternativeSelectedEvent>;

    @Output('onSubProductTabSelected')
    public subProductTabSelected: EventEmitter<SubProductTabSelectedEvent>;

    public selectedProduct: Product;
    public lastSelectedProduct: Product;
    public lastSelectedSubProduct: SubProduct;


    public sidebarContainerShown = false;

    public defaultImage = 'img/default_image.gif';

    public title;

    public sidebarState: string = 'collapsed';
    public subProductTab: string = 'subproducts';

    constructor(public translate: TranslateService, public el: ElementRef, public windowService: WindowService, public logger: Logger, public eventBus: EventsService) {
        this.displayEvent = new EventEmitter<boolean>();
        this.productInfo = new EventEmitter<Product>();
        this.productSelected = new EventEmitter<ProductSelectedEvent>();
        this.subProductSelected = new EventEmitter<SubProductSelectedEvent>();
        this.alternativeSelected = new EventEmitter<AlternativeSelectedEvent>();
        this.subProductTabSelected = new EventEmitter<SubProductTabSelectedEvent>();
        this.filterPanel = new EventEmitter<any>();
    }

    toggleSubproducts() {
        this.sidebarState = this.sidebarState === 'collapsed' ? 'expanded' : 'collapsed';
    }

    switchSubProductTab(tabName: string) {
        this.subProductTab = tabName;
    }

    hide() {
        this.isShown = false;
    }

    show() {
        this.isShown = true;
    }


    ngOnInit(): any {
        this.fitSidebar();
        this.windowService.addResizeEventListener(() => {
            this.fitSidebar();
        })
    }


    ngOnChanges(changes: any): any {
        // this.logger.debug(changes);
        if (typeof changes.productGroup !== 'undefined') {
            if (typeof this.selectedProduct !== 'undefined') {
                const selectedProduct = this.selectedProduct;
                setTimeout(function () {
                    const selectedProductArticleNumber = selectedProduct.articleNumber.getValue();

                    let selectedProductDiv = document.getElementById(selectedProductArticleNumber);
                    let productsContainer = document.getElementsByClassName('sidebar-product-inner');

                    productsContainer[0].scrollTop = selectedProductDiv.offsetTop - 300;
                }, 100);
            }

            if (changes.productGroup.currentValue instanceof ProductGroup) {
                this.title = changes.productGroup.currentValue.getName();
                // this.productGroup.getProducts()[0].isSelected = true;

                this.productGroup.getProducts().forEach((product) => {
                    if (product.isSelected) {
                        this.lastSelectedProduct = product;
                    }
                });

                this.productGroup.getSubProducts().forEach((subProduct) => {
                    if (subProduct.isSelected) {
                        // this.logger.debug(subProduct);
                        this.lastSelectedSubProduct = subProduct;
                    }
                });

            }

            if (this.productGroup && !this.productGroup.getSubProductName()) {
                this.subProductTab = 'alternatives';
            } else {
                this.subProductTab = 'subproducts';
            }
        }
        if ((typeof changes.productsFilters !== 'undefined' && this.productGroup instanceof ProductGroup)) {
            this.productsIterator = this.getProductsIterator();
        }
        if (typeof changes.productGroup !== 'undefined' && changes.productGroup.currentValue instanceof ProductGroup && changes.productGroup.currentValue !== changes.productGroup.previousValue) {
            this.productsFilters = [];
            this.productsIterator = this.getProductsIterator();
        }

        /*
         if (this.productGroup && !this.productGroup.getSubProductName()) {
         this.subProductTab = 'alternatives';
         } else {
         this.subProductTab = 'subproducts';
         }
         */
    }

    getProductsIterator() {
        let columns = this.configuration.ProductColumns || 3;
        let products = this.productGroup.getProducts().filter((product) => {
            return this.needToShowProduct(product);
        });
        let productsIterator = new RowsIterator<Product>(products, columns);
        return productsIterator;
    }

    fitSidebar() {
        let zoom = this.windowService.getScreenZoom();
        let height = this.windowService.getScreenHeight();
        let sidebar = this.el.nativeElement.querySelector('.sidebar') as HTMLElement;
        // let overlay = window.document.querySelector('.sidebar-overlay');
        let showControl = window.document.querySelector('.show-menu .control-btn') as HTMLElement;
        let inner = this.el.nativeElement.querySelector('.sidebar-product-inner') as HTMLElement;
        let container = this.el.nativeElement.querySelector('.sidebar-container') as HTMLElement;
        sidebar.style.height = (this.windowService.convertSize(height) - (62 * 2 + 30)) + 'px';
        inner.style.height = (this.windowService.convertSize(height) - (62 * 2 + 350)) + 'px';

        // debugger;
        let screenWidth = this.windowService.getScreenWidth();
        let mainContainerWidth = this.windowService.getMainContainerWidth();
        let aspectRatio = this.windowService.getAspectRatio();
        let realAspectRatio = this.windowService.getRealAspectRatio();

        sidebar.style.marginLeft = -1 * (this.windowService.convertSize(mainContainerWidth / 2)) + 'px';
        showControl.style.marginLeft = -1 * (this.windowService.convertSize(mainContainerWidth / 2)) + 'px';
        container.style.marginLeft = '0px';

    }

    scrollTop() {
        let container = this.el.nativeElement.querySelector('.sidebar-product-inner');
        let prevTop = container.scrollTop;
        this.scrollAnimate(container, -300, 2000);
    }

    scrollBottom() {
        let container = this.el.nativeElement.querySelector('.sidebar-product-inner');
        let prevTop = container.scrollTop;
        this.scrollAnimate(container, 300, 2000);
    }

    scrollAnimate(el: any, margin: number, scrollDuration: number) {
        let easing = new Easing(el);
        easing.easeOut({ scrollTop: el.scrollTop + margin }, scrollDuration);
    }

    showProductInfo(product: Product) {
        this.productInfo.emit(product);
    }

    showFilterPanel() {
        this.filterPanel.emit();
    }

    onProductSelected(event?: ProductSelectedEvent) {
        if (this.lastSelectedProduct === undefined || (this.productGroup.getName() == event.productGroup.getName() && this.lastSelectedProduct && this.lastSelectedProduct.id.getValue() == event.product.id.getValue() && this.lastSelectedProduct.articleNumber.getValue() == event.product.articleNumber.getValue())) {
            this.eventBus.broadcast("products.renderImageLoaded." + event.product.id.getValue() + "-" + event.product.articleNumber.getValue(), { product: event.product });
        }

        this.selectedProduct = event.product;
        this.lastSelectedProduct = event.product;
        this.productSelected.emit(event);
    }

    onSubProductSelected(event?: SubProductSelectedEvent) {
        if (this.lastSelectedSubProduct === undefined || (this.productGroup.getName() == event.productGroup.getName() && this.lastSelectedSubProduct.id.getValue() == event.subProduct.id.getValue() && this.lastSelectedSubProduct.articleNumber.getValue() == event.subProduct.articleNumber.getValue())) {
            this.eventBus.broadcast("subProducts.renderImageLoaded." + event.subProduct.id.getValue() + "-" + event.subProduct.articleNumber.getValue(), { product: event.subProduct });
        }

        this.lastSelectedSubProduct = event.subProduct;
        this.subProductSelected.emit(event);
    }

    onAlternativeSelected(event: AlternativeSelectedEvent) {
        // if (this.productGroup.getAltNumber() == event.altNumber) {
        //     this.eventBus.broadcast("products.renderImageLoaded", {product: event.product});
        // }

        this.alternativeSelected.emit(event);
    }

    showExpandTitle() {
        let showMore;
        let showLess;

        this.translate.get(["_sideBar.showMore", "_sideBar.showLess"])
            .subscribe((res: Object) => {
                showMore = res['_sideBar.showMore'];
                showLess = res['_sideBar.showLess'];
            });

        return this.sidebarState == 'collapsed' ? showMore : showLess;
    }

    needToShowProduct(product: Product) {

        if (this.productsFilters && this.productsFilters.length > 0) {
            // debugger;
            let groups = {};
            this.productsFilters.forEach((filterGroup: { type: string, list: Array<any> }) => {
                if ((filterGroup.list.length > 0)) {
                    groups[filterGroup.type] = false; // if any filter is checked then hide by default
                }
            });

            this.productsFilters.forEach((filterGroup: { type: string, list: Array<any> }) => {
                let type = filterGroup.type;
                product.filters.forEach((pFilter) => {
                    if (pFilter.type == type) {
                        let found = filterGroup.list.filter((filterValue) => {
                            if (filterValue == pFilter.value) {
                                return true;
                            }
                        });
                        if (found && found.length > 0) {
                            groups[type] = true;
                            // if(Object.keys(groups).length > 1) {
                            //     debugger;
                            // }
                        }
                    }
                });
            });
            let res = true;
            for (let g in groups) {
                res = groups[g] && res;
            }
            return res;

        } else {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts